import { capitalize } from "@datassential/platform-ui-lib";
import { PopularityTrendGapKeyword } from "@apiHooks/useCategoryProfilePopularityTrendGap";
import { CategoryProfileMenuChart } from "@apiHooks/useCategoryProfileMenu";

/**
 * Builds the display title for an instant chart as "[subCategoryName]: [instantChartName]".
 * Falls back to the chart name alone when the API returns no subcategory.
 */
export function formatMenuChartTitle(
    chart: Pick<CategoryProfileMenuChart, "instantChartName" | "subCategoryName"> | undefined,
): string {
    const name = capitalize(chart?.instantChartName ?? '');
    const subCategory = capitalize(chart?.subCategoryName ?? '');

    return subCategory ? `${subCategory}: ${name}` : name;
}

/**
 * Builds a Build-Your-Own URL for the Menu Trends product by appending
 * encoded keywords as a query parameter.
 *
 * @param baseUrl - The base URL from the product config (may be null/undefined)
 * @param keywords - Array of keyword objects with optional wordName property
 * @returns The constructed URL with keywords query parameter, or null if baseUrl is falsy
 */
export function buildMenuTrendsByoUrl(
    baseUrl: string | null | undefined,
    keywords: PopularityTrendGapKeyword[],
): string | null {
    if (!baseUrl) return null;

    const encodedKeywords = keywords
        .map(k => k.wordName)
        .filter(Boolean)
        .map(n => encodeURIComponent(n as string))
        .join(',');

    return encodedKeywords ? `${baseUrl}?keywords=${encodedKeywords}` : baseUrl;
}
